import z from "zod";
export const CreateMentalHealthCareProviderRequestSchema = z.object({
    name: z.string().trim().min(1, "Name is required"),
    email: z.string().trim().toLowerCase().pipe(z.email("Invalid email address")),
    trustId: z.uuid("Invalid trust ID").nullish(),
});
export const UpdateMentalHealthCareProviderRequestSchema = CreateMentalHealthCareProviderRequestSchema;
//# sourceMappingURL=mentalHealthCareProviderRequests.js.map